/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} No_Field_ValueInputs */

const en_no_field_value = /** @type {(inputs: No_Field_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.field}`)
};

const de_no_field_value = /** @type {(inputs: No_Field_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ohne ${i?.field}`)
};

/**
* | output |
* | --- |
* | "No {field}" |
*
* @param {No_Field_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_field_value = /** @type {((inputs: No_Field_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Field_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_field_value(inputs)
	return en_no_field_value(inputs)
});